const state = {
    showLucasDialog: false,
    lucasData: {
        x: [],
        y: []
    },
    showPlotDialog: false,
    plotData: {
        x: [],
        y: []
    },
    plotLayout: {
        title: "",
        xaxis: {
            title: ""
        },
        yaxis: {
            title: ""
        }
    }
}
const getters = {
    getPlotData: state => {
        return state.plotData
    },
    getPlotLayout: state => {
        return state.plotLayout
    }
}
const mutations = {
    SET_LUCAS_DIALOG(state, value) {
        state.showLucasDialog = value
    },
    SET_LUCAS_DATA(state, data){
        state.lucasData = data
    },
    SET_PLOT_DIALOG(state, value) {
        state.showPlotDialog = value
    },
    SET_PLOT_DATA(state, data) {
        state.plotData = data
    },
    SET_PLOT_LAYOUT(state, data) {
        state.plotLayout = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
};